import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  makeStyles,
  Theme,
  Tooltip,
} from '@material-ui/core';
import { Error } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) => ({
  titleCell: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
    fontWeight: 'bold',
  },
  labelCell: {
    width: '40%',
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
  },
  valueCell: {
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
  },
  matchCell: {
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    borderBottom: '1px solid #E0E0E0',
    padding: theme.spacing(1.5, 2),
    textAlign: 'center',
    width: '5%',
  },
  lastRow: {
    '& td': {
      borderBottom: 'none',
    },
  },
}));

export interface SellerEntityDocumentsReviewTableProps {
  data: Record<string, any>;
}

export const SellerEntityDocumentsReviewTable = ({ data }: SellerEntityDocumentsReviewTableProps) => {
  const classes = useStyles();
  const extractedEntityName = data.extractedEntityName;
  if (extractedEntityName === null || extractedEntityName === undefined) return null;

  const portalSellerEntityName = data.portalSellerEntityName;
  const isFlagged = data.entityNamesMatch === false;

  return (
    <Table>
      <TableBody>
        <TableRow>
          <TableCell className={classes.matchCell} />
          <TableCell className={classes.titleCell}>Field</TableCell>
          <TableCell className={classes.titleCell}>Portal</TableCell>
          <TableCell className={classes.titleCell}>Document</TableCell>
        </TableRow>
        <TableRow className={classes.lastRow}>
          <TableCell className={classes.matchCell}>
            {isFlagged && (
              <Tooltip title="Seller Entity is not matching the Seller Name in the collateral. Please review manually">
                <Error color="error" />
              </Tooltip>
            )}
          </TableCell>
          <TableCell className={classes.labelCell}>Seller Entity Name</TableCell>
          <TableCell className={classes.valueCell}>
            {portalSellerEntityName === null || portalSellerEntityName === undefined
              ? '—'
              : String(portalSellerEntityName)}
          </TableCell>
          <TableCell className={classes.valueCell}>{String(extractedEntityName)}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
